export const RESOLVE_LINK = "RESOLVE_LINK";
